import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as jsxRuntime from 'react/jsx-runtime'
import * as publicApi from './public-api'

/**
 * The object extension bundles read their dependencies from. Their build maps
 * `react` → `DistribuAI.sdk.React`, `react/jsx-runtime` → `…jsxRuntime`,
 * `react-dom` → `…ReactDOM` and `@distribuai/sdk` → `DistribuAI.sdk`, so an
 * extension uses this app's single React instance and its providers.
 */
export const sdkRuntime = { ...publicApi, React, ReactDOM, jsxRuntime }

export type SdkRuntime = typeof sdkRuntime

declare global {
    interface Window {
        DistribuAI?: { sdk: SdkRuntime }
    }
}

/** Must run before any extension script loads. */
export function installSdk(): void {
    window.DistribuAI = { sdk: sdkRuntime }
}
